import React, { useEffect, useState, useMemo } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";

import * as brandActions from "src/redux/actions/brand.action";
import * as departmentActions from "src/redux/actions/department.action";
import * as yearActions from "src/redux/actions/year.action";
import * as budgetsActions from "src/redux/actions/budgets.action";
import * as budgetsdetailActions from "src/redux/actions/budgetsdetail.action";
import * as getforecastoneActions from "src/redux/actions/getforecastone.action";
import * as getforecasttwoActions from "src/redux/actions/getforecasttwo.action";
import * as getforecastthreeActions from "src/redux/actions/getforecastthree.action";
import * as getforecastfourActions from "src/redux/actions/getforecastfour.action";
import * as getforecastfiveActions from "src/redux/actions/getforecastfive.action";
import * as updateforecastActions from "src/redux/actions/updateforecast.action";

import { useParams } from "react-router-dom";
import {
  AppBar,
  Tabs,
  Tab,
  TextField,
  Grid,
  Typography,
  makeStyles,
  Button,
  Icon,
  Modal,
  Backdrop,
  Fade,
  Card,
  CardActions,
  CardContent,
  MenuItem,
  Paper,
  Box,
  ButtonGroup,
  CircularProgress,
  TableFooter,
  Container,
  CardHeader,
  Divider,
} from "@material-ui/core";
import { Alert, Pagination } from "@material-ui/lab";
// import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import CustomDialog from "src/components/fragments/CustomDialog";
import PopupDialog from "src/components/fragments/PopupDialog";
import { Formik, Form, Field } from "formik";
import {
  TimePicker,
  DatePicker,
  DateTimePicker,
} from "formik-material-ui-pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  TextField as TextFieldFormik,
  CheckBox as CheckBoxFormik,
} from "formik-material-ui";
import Moment from "moment";
import { httpClient } from "src/utils/HttpClient";
import { result, isNull, set } from "lodash";
import NumberFormat from "react-number-format";
import budgetsdetailReducer from "src/redux/reducers/budgetsdetail.reducer";
import Page from "src/components/Page";
// import budgetssidReducer from "src/redux/reducers/budgetssid.reducer";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  formsearch: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "40ch",
    },
  },
  inputEditNumber: {
    width: "30ch",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function BudgetForecast() {
  const classes = useStyles();

  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [openModalApprove, setopenModalApprove] = useState(false);
  const [openinvestment, setOpeninvestment] = useState(false);
  const [openinvestmentedit, setOpeninvestmentedit] = useState(false);
  const [openDlgconfirm, setopenDlgconfirm] = useState(false);
  const [openDlgconfirmBudget, setopenDlgconfirmBudget] = useState(false);
  const [openPopupDlg, setOpenPopupDlg] = useState(false);
  const [openPopupDlgSucc, setOpenPopupDlgSucc] = useState(false);

  const [budgetpId, setbudgetpId] = useState(0);
  const [brandId, setBrandId] = useState(null);
  const [deptId, setDeptId] = useState(null);
  const [yearId, setYearId] = useState(null);
  const [onSubmit, setOnSubmit] = useState(false);
  const [buheadFullname, setbuheadFullname] = useState("");
  const [yearCode, setyearCode] = useState();
  const [yearCode1, setyearCode1] = useState();
  const [yearCode2, setyearCode2] = useState();
  const [yearCode3, setyearCode3] = useState();
  const [yearCode4, setyearCode4] = useState();
  const [yearCode5, setyearCode5] = useState();

  const [yearLock, setYearLock] = useState(null);
  // const [yearmaxDate, setMaxDate] = useState("12/31/" + yearCode);
  // const [yearminDate, setMinDate] = useState("01/01/" + yearCode);

  const loginReducer = useSelector((state) => state.loginReducer);
  const budgetmonthReducer = useSelector(
    ({ budgetmonthReducer }) => budgetmonthReducer
  );
  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(({ budgetsReducer }) => budgetsReducer);
  const brandReducer = useSelector(({ brandReducer }) => brandReducer);
  const departmentReducer = useSelector(
    ({ departmentReducer }) => departmentReducer
  );

  const getforecastoneReducer = useSelector(
    (state) => state.getforecastoneReducer
  );
  const getforecasttwoReducer = useSelector(
    (state) => state.getforecasttwoReducer
  );
  const getforecastthreeReducer = useSelector(
    (state) => state.getforecastthreeReducer
  );
  const getforecastfourReducer = useSelector(
    (state) => state.getforecastfourReducer
  );
  const getforecastfiveReducer = useSelector(
    (state) => state.getforecastfiveReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // Get Brand

    dispatch(
      brandActions.getBrands(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid
      )
    );

    return () => {
      clearDataDropDown();
      dispatch(
        departmentActions.getDepts(loginReducer.result.countryid, 0, 0, 0)
      );
      dispatch(
        yearActions.getYear(
          loginReducer.result.countryid + loginReducer.result.companyid + 0 + 0
        )
      );
      dispatch(budgetsActions.clearBudgets());
    };
  }, []);

  const checkEditExpense = (rowData) => {
    if (yearLock === 0) {
      if (budgetsReducer.actid === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const handleChangeBrand = (e) => {
    const data = e.target.value;
    clearDataDropDown();
    setBrandId(data);
    // dispatch(getforecastoneActions.clearForecast1());
    setDeptId(null);
    // setOnSubmit(false);
    dispatch(
      departmentActions.getDepts(
        loginReducer.result.countryid,
        loginReducer.result.companyid,
        loginReducer.result.secureid,
        data
      )
    );
    dispatch(
      yearActions.getYear(
        loginReducer.result.countryid + loginReducer.result.companyid + 0 + 0
      )
    );
  };

  const handleChangeDepartment = (e) => {
    const data = e.target.value;
    setDeptId(data);
    clearDataDropDown();
    setYearId(null);
    // setOnSubmit(false);
    dispatch(
      yearActions.getYear(
        loginReducer.result.countryid +
          loginReducer.result.companyid +
          brandId +
          data
      )
    );
  };

  const handleChangeYear = (e) => {
    const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = JSON.parse(e.target.value);

    clearDataDropDown();
    setYearId(BUDGETH_ID);
    setyearCode(YEAR_CODE);
    setyearCode1(YEAR_CODE + 1);
    setyearCode2(YEAR_CODE + 2);
    setyearCode3(YEAR_CODE + 3);
    setyearCode4(YEAR_CODE + 4);
    setyearCode5(YEAR_CODE + 5);

    setYearLock(BUDGETH_LOCK);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleConfirmDlg = (value) => {
    if (value) {
      // setTimeout(() => {
      // dispatch(deleteprojectActions.deleteProjectById(budgetpId));
      // }, 1000),
      setTimeout(() => {
        // dispatch(getprojectActions.getProject(budgetsReducer.sid));
      }, 1000);
    }
    setopenDlgconfirm(false);
  };
  const handleConfirmDlgBudget = (value) => {
    if (value) {
      // e.preventDefault();
      let data = {
        YEARID: yearId,
        COUNTRYID: loginReducer.result.countryid,
        COMPANYID: loginReducer.result.companyid,
        BRANDID: brandId,
        DEPARTID: deptId,
        MEMID: loginReducer.result.perid,
        SECID: loginReducer.result.secureid,
      };

      setTimeout(() => {
        // dispatch(insertbudgetsActions.insertBudgetsById(data));
      }, 1000);
      setTimeout(() => {
        dispatch(
          budgetsActions.getBudgetsById(
            loginReducer.result.countryid,
            loginReducer.result.companyid,
            brandId,
            deptId,
            yearId,
            loginReducer.result.secureid
          )
        );
      }, 1000);
      dispatch(
        budgetsdetailActions.getBudgetsDetail(
          loginReducer.result.countryid,
          loginReducer.result.companyid,
          brandId,
          deptId,
          yearId,
          loginReducer.result.secureid
        )
      );
      setopenDlgconfirmBudget(false);
    } else {
      setopenDlgconfirmBudget(false);
    }
  };

  const handlePopupDlgSucc = (value) => {
    if (value) {
      setOpenPopupDlgSucc(false);
    }
  };

  const clearDataDropDown = () => {
    dispatch(getforecastoneActions.clearForecast1());
    dispatch(getforecasttwoActions.clearForecast2());
    dispatch(getforecastthreeActions.clearForecast3());
    dispatch(getforecastfourActions.clearForecast4());
    dispatch(getforecastfiveActions.clearForecast5());
  };

  const tableRefDetail = React.createRef();

  return (

    
   <Page className={classes.root} title="Budget Forecast">
   <Container maxWidth={false}>
     <Card>
       <CardHeader subheader="For forecast budget" title="Budget Forecast" />
       {yearLock === 1 ? (
         <Alert icon={false} severity="warning">
           <Typography variant="button" display="block">
             Year Locked
           </Typography>
         </Alert>
       ) : (
         ""
       )}
       {budgetsReducer.actid + budgetsReducer.appid > 1 ? (
           <Alert icon={false} severity="success">
             <Typography variant="button" display="block">
               Approved.
             </Typography>
           </Alert>
         ) : budgetsReducer.actid === 1 ? (
           <Alert icon={false} severity="warning">
             <Typography variant="button" display="block">
               Waiting for approve.
             </Typography>
           </Alert>
         ) : (
           ""
         )}
       <Divider />
       <CardContent>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(
            getforecastoneActions.getForecast1(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearCode,
              yearId
            )
          );
          dispatch(
            getforecasttwoActions.getForecast2(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearCode,
              yearId
            )
          );
          dispatch(
            getforecastthreeActions.getForecast3(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearCode,
              yearId
            )
          );
          dispatch(
            getforecastfourActions.getForecast4(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearCode,
              yearId
            )
          );
          dispatch(
            getforecastfiveActions.getForecast5(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearCode,
              yearId
            )
          );          
          dispatch(
            budgetsActions.getBudgetsById(
              loginReducer.result.countryid,
              loginReducer.result.companyid,
              brandId,
              deptId,
              yearId,
              loginReducer.result.secureid
            )
          )
            .then((result) => {
              setTimeout(() => {
                if (result) {
                } else {
                }
              }, 1000);
            })
            .catch((result) => {});
        }}
      >
        <Grid container xs={12}>
          <Box
            display="flex"
            flexWrap="wrap"
            flex={1}
            style={{ lineHeight: 4, justifyContent: "space-between" }}
          >
            <TextField
              variant="outlined"
              margin="normal"
              required
              select
              onChange={handleChangeBrand}
              id="brand"
              label="Brand"
              autoComplete="investmenttype"
              autoFocus
              style={{ width: "20%", minWidth: "10%" }}
              SelectProps={{
                native: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              defaultValue=""
            >
              <option key={0} value="" selected>
                -
              </option>
              {brandReducer.result &&
                brandReducer.result.map((item) => (
                  <option key={item.ORG_BRAND_ID} value={item.ORG_BRAND_ID}>
                    {item.BRAND}
                  </option>
                ))}
            </TextField>
            <TextField
              variant="outlined"
              margin="normal"
              required
              select
              style={{ width: "50%" }}
              // value={deptId}
              onChange={handleChangeDepartment}
              label="Department"
              SelectProps={{
                native: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              defaultValue=""
            >
              <option key={0} value="" selected>
                -
              </option>
              {departmentReducer.result &&
                departmentReducer.result.map((item) => (
                  <option
                    key={item.ORG_DEPARTMENT_ID}
                    value={item.ORG_DEPARTMENT_ID}
                  >
                    {item.department}
                  </option>
                ))}
            </TextField>
            <TextField
              variant="outlined"
              margin="normal"
              required
              select
              onChange={handleChangeYear}
              label="Year"
              style={{ width: "10%" }}
              SelectProps={{
                native: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              defaultValue=""
            >
              <option key={0} value="" selected>
                -
              </option>
              {yearReducer.result &&
                yearReducer.result.map((item) => (
                  // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                  <option key={item.YEAR_CODE} value={JSON.stringify(item)}>
                    {/* {item.YEAR_CODE} */}
                    {item.YEAR_SEQ_T}
                  </option>
                ))}
            </TextField>
            <Box>
              <Button variant="contained" color="default" type="submit">
                <Icon>search</Icon>Search
              </Button>
            </Box>
          </Box>
        </Grid>
      </form>
      <br />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" flexWrap="wrap">
            <Box display="flex" flexDirection="row"></Box>
            {/* <Box display="flex" flexDirection="row">
              <Box>
                <Button
                  variant="contained"
                  color="default"
                  // disabled={checkRecBudget}
                  startIcon={<Icon>refresh</Icon>}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(
                      getforecastoneActions.getForecast1(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearCode
                      )
                    );
                    dispatch(
                      getforecasttwoActions.getForecast2(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearCode
                      )
                    );
                    dispatch(
                      getforecastthreeActions.getForecast3(
                        loginReducer.result.countryid,
                        loginReducer.result.companyid,
                        brandId,
                        deptId,
                        yearCode
                      )
                    );
                  }}
                >
                  Refresh data
                </Button>
              </Box>
            </Box> */}
          </Box>
        </Grid>
      </Grid>

      <br />

      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          variant="fullWidth"
          centered
        >
          <Tab
            style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
            label={yearCode1 + 1 ? "Forecast : " + yearCode1 : "Forecast : 1"}
            {...a11yProps(0)}
          />
          <Tab
            style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
            label={yearCode2 + 1 ? "Forecast : " + yearCode2 : "Forecast : 2"}
            {...a11yProps(1)}
          />
          <Tab
            style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
            label={yearCode3 + 1 ? "Forecast : " + yearCode3 : "Forecast : 3"}
            {...a11yProps(2)}
          />
          <Tab
            style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
            label={yearCode4 + 1 ? "Forecast : " + yearCode4 : "Forecast : 4"}
            {...a11yProps(3)}
          />
          <Tab
            style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
            label={yearCode5 + 1 ? "Forecast : " + yearCode5 : "Forecast : 5"}
            {...a11yProps(4)}
          />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        {/* Forecast +1 Tab */}
        <Grid container spacing={2}>
          <Paper className={classes.root}>
            <MaterialTable
              title={yearCode1 ? "Forecast : " + yearCode1 : "Forecast"}
              // isLoading={approvebudgetReducer.isFetching}
              on
              columns={[
                {
                  title: "seq",
                  field: "R_SEQ",
                  hidden: true,
                  // width: 50,
                },
                {
                  title: "Group",
                  field: "R_GROUP",
                  width: 50,
                  editable: false,
                },
                {
                  title: "Group Name",
                  field: "R_NAME",
                  editable: false,
                },

                {
                  title: "Total Amount",
                  field: "B_VALUE",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.B_VALUE) {
                      return rowData.B_VALUE.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                  editComponent: (props) => (
                    <TextField
                      className={classes.inputEditNumber}
                      // label="react-number-format"
                      value={props.value}
                      onChange={(e) =>
                        props.onChange(e.target.value ? e.target.value : 0)
                      }
                      name="numberformat"
                      id="formatted-numberformat-input"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                  ),
                },
              ]}
              data={
                getforecastoneReducer.result ? getforecastoneReducer.result : []
              }
              editable={{
                isEditable: (rowData) => checkEditExpense(rowData),
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    const { R_GROUP, B_VALUE } = newData;
                    let dataF1 = {
                      COUNTRYID: loginReducer.result.countryid,
                      COMPANYID: loginReducer.result.companyid,
                      BRANDID: brandId,
                      DEPARTID: deptId,
                      YEARCODE: yearCode,
                      B_VALUE: B_VALUE,
                      S_SEQ: 3,
                      GRP_TY: R_GROUP,
                      MEMID: loginReducer.result.perid,
                      HID: yearId,
                    };
                    setTimeout(() => {
                      dispatch(updateforecastActions.updateForecast(dataF1));
                    }, 1000);
                    setTimeout(() => {
                      dispatch(
                        getforecastoneActions.getForecast1(
                          loginReducer.result.countryid,
                          loginReducer.result.companyid,
                          brandId,
                          deptId,
                          yearCode,
                          yearId
                        )
                      );
                    }, 1000);
                    resolve(newData);
                  }),
              }}
              options={{
                // selection: true,
                headerStyle: {
                  backgroundColor: "#5c9aff",
                },
                rowStyle: {
                  backgroundColor: "#edf4ff",
                },
                // showTitle: false,
                // searchFieldAlignment: "left",
                pageSize: 10,
                pageSizeOptions: [10, 50, 100],
                paging: true,
              }}
            />
          </Paper>
        </Grid>
      </TabPanel>

      <TabPanel value={value} index={1}>
        {/* Forecast +2 Tab */}
        <Grid container spacing={2}>
          <Paper className={classes.root}>
            <MaterialTable
              title={yearCode2 ? "Forecast : " + yearCode2 : "Forecast"}
              // isLoading={approvebudgetReducer.isFetching}
              on
              columns={[
                {
                  title: "seq",
                  field: "R_SEQ",
                  hidden: true,
                  // width: 50,
                },
                {
                  title: "Group",
                  field: "R_GROUP",
                  width: 50,
                  editable: false,
                },
                {
                  title: "Group Name",
                  field: "R_NAME",
                  editable: false,
                },

                {
                  title: "Total Amount",
                  field: "B_VALUE",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.B_VALUE) {
                      return rowData.B_VALUE.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                  editComponent: (props) => (
                    <TextField
                      className={classes.inputEditNumber}
                      // label="react-number-format"
                      value={props.value}
                      onChange={(e) =>
                        props.onChange(e.target.value ? e.target.value : 0)
                      }
                      name="numberformat"
                      id="formatted-numberformat-input"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                  ),
                },
              ]}
              editable={{
                isEditable: (rowData) => checkEditExpense(rowData),
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    const { R_GROUP, B_VALUE } = newData;
                    let dataF2 = {
                      COUNTRYID: loginReducer.result.countryid,
                      COMPANYID: loginReducer.result.companyid,
                      BRANDID: brandId,
                      DEPARTID: deptId,
                      YEARCODE: yearCode,
                      B_VALUE: B_VALUE,
                      S_SEQ: 4,
                      GRP_TY: R_GROUP,
                      MEMID: loginReducer.result.perid,
                      HID: yearId,
                    };
                    setTimeout(() => {
                      dispatch(updateforecastActions.updateForecast(dataF2));
                    }, 1000);
                    setTimeout(() => {
                      dispatch(
                        getforecasttwoActions.getForecast2(
                          loginReducer.result.countryid,
                          loginReducer.result.companyid,
                          brandId,
                          deptId,
                          yearCode,
                          yearId
                        )
                      );
                    }, 1000);
                    resolve(newData);
                  }),
              }}
              data={
                getforecasttwoReducer.result ? getforecasttwoReducer.result : []
              }
              options={{
                // selection: true,
                headerStyle: {
                  backgroundColor: "#5c9aff",
                },
                rowStyle: {
                  backgroundColor: "#edf4ff",
                },
                // showTitle: false,
                // searchFieldAlignment: "left",
                pageSize: 10,
                pageSizeOptions: [10, 50, 100],
                paging: true,
              }}
            />
          </Paper>
        </Grid>
      </TabPanel>

      <TabPanel value={value} index={2}>
        {/* Forecast +3 Tab*/}
        <Grid container spacing={2}>
          <Paper className={classes.root}>
            <MaterialTable
              // title="Forecast 3 Year"
              title={yearCode3 ? "Forecast : " + yearCode3 : "Forecast"}
              // isLoading={approvebudgetReducer.isFetching}
              on
              columns={[
                {
                  title: "seq",
                  field: "R_SEQ",
                  hidden: true,
                  // width: 50,
                },
                {
                  title: "Group",
                  field: "R_GROUP",
                  width: 50,
                  editable: false,
                },
                {
                  title: "Group Name",
                  field: "R_NAME",
                  editable: false,
                },

                {
                  title: "Total Amount",
                  field: "B_VALUE",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.B_VALUE) {
                      return rowData.B_VALUE.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                  editComponent: (props) => (
                    <TextField
                      className={classes.inputEditNumber}
                      // label="react-number-format"
                      value={props.value}
                      onChange={(e) =>
                        props.onChange(e.target.value ? e.target.value : 0)
                      }
                      name="numberformat"
                      id="formatted-numberformat-input"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                  ),
                },
              ]}
              editable={{
                isEditable: (rowData) => checkEditExpense(rowData),
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    const { R_GROUP, B_VALUE } = newData;
                    let dataF3 = {
                      COUNTRYID: loginReducer.result.countryid,
                      COMPANYID: loginReducer.result.companyid,
                      BRANDID: brandId,
                      DEPARTID: deptId,
                      YEARCODE: yearCode,
                      B_VALUE: B_VALUE,
                      S_SEQ: 5,
                      GRP_TY: R_GROUP,
                      MEMID: loginReducer.result.perid,
                      HID: yearId,
                    };
                    setTimeout(() => {
                      dispatch(updateforecastActions.updateForecast(dataF3));
                    }, 1000);
                    setTimeout(() => {
                      dispatch(
                        getforecastthreeActions.getForecast3(
                          loginReducer.result.countryid,
                          loginReducer.result.companyid,
                          brandId,
                          deptId,
                          yearCode,
                          yearId
                        )
                      );
                    }, 1000);
                    resolve(newData);
                  }),
              }}
              data={
                getforecastthreeReducer.result
                  ? getforecastthreeReducer.result
                  : []
              }
              options={{
                // selection: true,
                headerStyle: {
                  backgroundColor: "#5c9aff",
                },
                rowStyle: {
                  backgroundColor: "#edf4ff",
                },
                // showTitle: false,
                // searchFieldAlignment: "left",
                pageSize: 10,
                pageSizeOptions: [10, 50, 100],
                paging: true,
              }}
            />
          </Paper>
        </Grid>
      </TabPanel>

      <TabPanel value={value} index={3}>
        {/* Forecast +4 Tab*/}
        <Grid container spacing={2}>
          <Paper className={classes.root}>
            <MaterialTable
              // title="Forecast 4 Year"
              title={yearCode4 ? "Forecast : " + yearCode4 : "Forecast"}
              // isLoading={approvebudgetReducer.isFetching}
              on
              columns={[
                {
                  title: "seq",
                  field: "R_SEQ",
                  hidden: true,
                  // width: 50,
                },
                {
                  title: "Group",
                  field: "R_GROUP",
                  width: 50,
                  editable: false,
                },
                {
                  title: "Group Name",
                  field: "R_NAME",
                  editable: false,
                },

                {
                  title: "Total Amount",
                  field: "B_VALUE",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.B_VALUE) {
                      return rowData.B_VALUE.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                  editComponent: (props) => (
                    <TextField
                      className={classes.inputEditNumber}
                      // label="react-number-format"
                      value={props.value}
                      onChange={(e) =>
                        props.onChange(e.target.value ? e.target.value : 0)
                      }
                      name="numberformat"
                      id="formatted-numberformat-input"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                  ),
                },
              ]}
              editable={{
                isEditable: (rowData) => checkEditExpense(rowData),
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    const { R_GROUP, B_VALUE } = newData;
                    let dataF4 = {
                      COUNTRYID: loginReducer.result.countryid,
                      COMPANYID: loginReducer.result.companyid,
                      BRANDID: brandId,
                      DEPARTID: deptId,
                      YEARCODE: yearCode,
                      B_VALUE: B_VALUE,
                      S_SEQ: 9,
                      GRP_TY: R_GROUP,
                      MEMID: loginReducer.result.perid,
                      HID: yearId,
                    };
                    setTimeout(() => {
                      dispatch(updateforecastActions.updateForecast(dataF4));
                    }, 1000);
                    setTimeout(() => {
                      dispatch(
                        getforecastfourActions.getForecast4(
                          loginReducer.result.countryid,
                          loginReducer.result.companyid,
                          brandId,
                          deptId,
                          yearCode,
                          yearId
                        )
                      );
                    }, 1000);
                    resolve(newData);
                  }),
              }}
              data={
                getforecastfourReducer.result
                  ? getforecastfourReducer.result
                  : []
              }
              options={{
                // selection: true,
                headerStyle: {
                  backgroundColor: "#5c9aff",
                },
                rowStyle: {
                  backgroundColor: "#edf4ff",
                },
                // showTitle: false,
                // searchFieldAlignment: "left",
                pageSize: 10,
                pageSizeOptions: [10, 50, 100],
                paging: true,
              }}
            />
          </Paper>
        </Grid>
      </TabPanel>

      <TabPanel value={value} index={4}>
        {/* Forecast +5 Tab*/}
        <Grid container spacing={2}>
          <Paper className={classes.root}>
            <MaterialTable
              // title="Forecast 5 Year"
              title={yearCode5 ? "Forecast : " + yearCode5 : "Forecast"}
              // isLoading={approvebudgetReducer.isFetching}
              on
              columns={[
                {
                  title: "seq",
                  field: "R_SEQ",
                  hidden: true,
                  // width: 50,
                },
                {
                  title: "Group",
                  field: "R_GROUP",
                  width: 50,
                  editable: false,
                },
                {
                  title: "Group Name",
                  field: "R_NAME",
                  editable: false,
                },

                {
                  title: "Total Amount",
                  field: "B_VALUE",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.B_VALUE) {
                      return rowData.B_VALUE.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                  editComponent: (props) => (
                    <TextField
                      className={classes.inputEditNumber}
                      // label="react-number-format"
                      value={props.value}
                      onChange={(e) =>
                        props.onChange(e.target.value ? e.target.value : 0)
                      }
                      name="numberformat"
                      id="formatted-numberformat-input"
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                  ),
                },
              ]}
              editable={{
                isEditable: (rowData) => checkEditExpense(rowData),
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    const { R_GROUP, B_VALUE } = newData;
                    let dataF5 = {
                      COUNTRYID: loginReducer.result.countryid,
                      COMPANYID: loginReducer.result.companyid,
                      BRANDID: brandId,
                      DEPARTID: deptId,
                      YEARCODE: yearCode,
                      B_VALUE: B_VALUE,
                      S_SEQ: 10,
                      GRP_TY: R_GROUP,
                      MEMID: loginReducer.result.perid,
                      HID: yearId,
                    };
                    setTimeout(() => {
                      dispatch(updateforecastActions.updateForecast(dataF5));
                    }, 1000);
                    setTimeout(() => {
                      dispatch(
                        getforecastfiveActions.getForecast5(
                          loginReducer.result.countryid,
                          loginReducer.result.companyid,
                          brandId,
                          deptId,
                          yearCode,
                          yearId
                        )
                      );
                    }, 1000);
                    resolve(newData);
                  }),
              }}
              data={
                getforecastfiveReducer.result
                  ? getforecastfiveReducer.result
                  : []
              }
              options={{
                // selection: true,
                headerStyle: {
                  backgroundColor: "#5c9aff",
                },
                rowStyle: {
                  backgroundColor: "#edf4ff",
                },
                // showTitle: false,
                // searchFieldAlignment: "left",
                pageSize: 10,
                pageSizeOptions: [10, 50, 100],
                paging: true,
              }}
            />
          </Paper>
        </Grid>
      </TabPanel>

      
      <CustomDialog
        title="Confirmation dialog"
        message="Confirm to delete Project ?"
        open={openDlgconfirm}
        onClose={handleConfirmDlg}
        disableBackdropClick
      />
      <CustomDialog
        title="Confirmation dialog"
        message="Confirm to Update budget?"
        open={openDlgconfirmBudget}
        onClose={handleConfirmDlgBudget}
        disableBackdropClick
      />

      <PopupDialog
        title="Information Message"
        message={<Alert severity="success">Submission successful.</Alert>}
        // disabledBtn={getfilesReducer.isFetching ? true : false}
        open={openPopupDlgSucc}
        onClose={handlePopupDlgSucc}
      />
          </CardContent>
        </Card>
      </Container>
    </Page>   
  );
}
